/**
 * @module: 组织机构部门和成员数据
 * @author: Teacher Tang
 * @date: 2019-11-05 14:19:03
 */

import { observable, action } from 'mobx';
import ywk from '@clouderwork/ywk';
import { IDepartment } from '@src/entity/monitor/entry';
import mobxState from '@src/store/monitor';
import * as dd from 'dingtalk-jsapi';

console.log('dd.env.platform', dd.env.platform);

interface ISimpleUser {
  uuid: string;
  name: string;
  avatar: string;
}

class Depart {
  // 是否加载中
  @observable departments: IDepartment = {
    avatar: null,
    children: [],
    key: 'department',
    title: mobxState.user.curUserInfo && mobxState.user.curUserInfo.permission === 'all' ? '全公司' : '部门和成员',
    type: 'department'
  };
  @observable selectUser: ISimpleUser = {
    uuid: '',
    name: '',
    avatar: ''
  };
  @observable outDepartments: any[] = [];
  // 选中的组织
  @observable selectDepart: { uuid: string; name: string } = { uuid: 'self', name: '请选择' };
  // 是否显示选择部门树
  @observable showDepart: boolean = false;
  // 组织部门下的全体成员
  @observable members: { uuid: string; name: string; type: string; avatar: string }[] = [];
  // 选择的所有成员的uuid
  @observable selectUuid: string = '';
  // 选择的部门和成员
  @observable selectMemberAndDepart: { uuid: string; name: string; type: string; avatar: string }[] = [];

  @observable fetchingDepartments: boolean = false;
  @observable memberLoading: boolean = false;

  /** 设置组织机构树显示与隐藏 */
  @action.bound
  showDepartMentFn(show: boolean) {
    this.showDepart = show;
  }

  /** 获取成员数据 */
  @action.bound
  getMembers(memberArr: { uuid: string; name: string; type: string; avatar: string }[]) {
    const { uuid, name } = this.selectDepart;
    if (uuid === 'self') {
      this.members = [];
      // 设置选中的用户为自己
      const curUserInfo = mobxState.user.curUserInfo;
      if (curUserInfo) {
        this.selectUser = {
          avatar: curUserInfo.avatar,
          name: curUserInfo.name || curUserInfo.nickname,
          uuid: curUserInfo.uuid
        };

        this.selectUuid = curUserInfo.uuid;
      }
    } else {
      this.memberLoading = true;
      this.members = memberArr;

      const membersUuid = memberArr.map(cur => cur.uuid);
      console.log('membersUuid+++++', membersUuid.join(','));
      this.selectUuid = membersUuid.join(',');

      if (this.selectUser && this.selectUser.uuid) {
        // 设置选中用户
        const idx = this.members.findIndex(cur => cur.uuid === this.selectUser.uuid);
        if (idx < 0 && this.members.length > 0) {
          this.selectUser = this.members[0];
        } else {
          this.selectUser = this.members[idx];
        }
      } else if (this.members.length > 0) {
        this.selectUser = this.members[0];
      } else {
        const curUserInfo = mobxState.user.curUserInfo;
        if (curUserInfo) {
          this.selectUser = {
            avatar: curUserInfo.avatar,
            name: curUserInfo.name || curUserInfo.nickname,
            uuid: curUserInfo.uuid
          };
        }
      }
    }
    this.memberLoading = false;
  }

  /** 设置当前的单选项*/
  @action.bound
  setSelectDepart(obj: { uuid: string; name: string }) {
    this.selectDepart = obj;
  }

  /** 设置当前的多选项 */
  @action.bound
  setSelectMemberAndDepart(arr: { uuid: string; name: string; type: string; avatar: string }[]) {
    this.selectMemberAndDepart = arr;
  }

  /** 设置当前过滤的用户信息 */
  @action.bound
  setSelectUser(user: any) {
    this.selectUser = user;
  }

  /** 获取部门树 */
  @action.bound
  async getDepartments() {
    this.fetchingDepartments = true;
    let outReq: Promise<any> = new Promise(() => {});
    const inReq = await ywk.ajax.getJson('/monitor/api/user/departments', {
      just_department: 0
    });

    if (
      mobxState.user.curUserInfo &&
      mobxState.user.curUserInfo.out_permission &&
      dd.env.platform === 'notInDingTalk'
    ) {
      outReq = this.getOutMembers();
    } else {
      outReq = Promise.resolve({ results: [] });
    }

    const inRes = await inReq;
    const outRes = await outReq;

    this.fetchingDepartments = false;

    if (outRes && inRes) {
      if (mobxState.user.curUserInfo && mobxState.user.curUserInfo.permission === 'all') {
        const childrenRes =
          dd.env.platform !== 'notInDingTalk'
            ? [...inRes.results.children]
            : [
                {
                  avatar: null,
                  children: outRes.results,
                  groupSeq: -1,
                  id: 'out',
                  jobPositionName: null,
                  key: 'out',
                  memberType: null,
                  phone: null,
                  title: '外部成员',
                  type: 'department'
                },
                ...inRes.results.children
              ];
        this.departments = {
          avatar: null,
          children: childrenRes,
          key: inRes.results.key,
          title: '全公司',
          type: 'department',
          id: 'all' // 根目录区分的用户权限
        };
      }
      if (mobxState.user.curUserInfo && mobxState.user.curUserInfo.permission === 'department') {
        this.departments = {
          avatar: null,
          children: [...inRes.results.children],
          key: 'department',
          title: '部门和成员',
          type: 'department',
          id: 'department' // 根目录区分的用户权限
        };
      }
      this.outDepartments = outRes.results;
    }
  }

  @action.bound
  getOutMembers() {
    return ywk.ajax.getJson('/monitor/api/user/out');
  }
}

export default Depart;
